/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-03 18:05:01
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-10 14:19:02
 */
export default [
  {
    path: '/operate-config',
    name: 'operate-config',
    meta: {
      name: '经营配置',
      keepAlive: true
    },
    component: () => import(/* webpackChunkName: "operate" */ '@/views/config-manager/operate-config/index.vue')
  },
 
]
